module.exports = __webpack_public_path__ + "img/Gaestebuch.02fbf70a.jpg";